import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { GraduationCap, Loader2 } from "lucide-react";

export function SecondProfileCard() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.primary_role !== "business") return null;
  const toggle = async (enabled) => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/second-profile", { enabled });
      setUser(data);
      toast.success(enabled ? "Perfil alumno habilitado. Lo encontrarás en el menú de tu cuenta." : "Perfil alumno deshabilitado");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Card className="p-5 max-w-2xl space-y-3 mt-6" data-testid="second-profile-card">
      <h3 className="font-bold flex items-center gap-2"><GraduationCap className="w-5 h-5 text-primary" />Perfil alumno</h3>
      <label className="flex items-start gap-3 cursor-pointer">
        <Checkbox checked={user.second_profile} disabled={busy} onCheckedChange={(v) => toggle(!!v)} className="mt-0.5" data-testid="second-profile-checkbox" />
        <span className="text-sm">Habilitar perfil maestro para actuar como perfil alumno</span>
        {busy && <Loader2 className="w-4 h-4 animate-spin text-primary" />}
      </label>
      <p className="text-xs text-muted-foreground">Al habilitarlo aparece «Mi perfil alumno» en el menú de tu cuenta para reservar talleres de otros Maestros. Solo puedes estar en un perfil a la vez. Puedes deshabilitarlo si no tienes reservas vigentes como alumno.</p>
    </Card>
  );
}
